import { snakeCase } from 'lodash'
import { Component, Mixins } from 'vue-property-decorator'

import { SelectOption } from '../../../logic/types'
import { FieldData, SelectOptionData } from '../../Pi/types'
import CurrenciesHelperMixin from "../CurrenciesHelperMixin";
import { XTR_CURRENCY } from "./constants";
import {
  CashRegisterDataType,
  CashRegisterType,
  CloudpaymentsRegister,
  Coinbase,
  Cryptobot,
  Cryptocloud,
  Nowpayments,
  PayboxMoneyType,
  Paypal,
  Prodamus,
  Robokassa,
  SberbankBusiness,
  StripeRegister,
  Telegram,
  Unitpay,
  WalletPayProvider,
  Yookassa,
  Yoomoney
} from './types'

@Component
export default class CashRegisterEditorMixin extends Mixins(CurrenciesHelperMixin) {
  // eslint-disable-next-line sonarjs/cognitive-complexity
  getCashRegisterDataByType(type: CashRegisterType): CashRegisterDataType {
    switch (type) {
      case CashRegisterType.Telegram:
        return {
          token: '',
          need_email: false,
          need_name: false,
          need_phone: false,
          need_address: false,
          validate(target) {
            if (target && target.currency === XTR_CURRENCY) {
              return true
            } else {
              return !!(this as Telegram).token.trim().length
            }
          }
        }
      case CashRegisterType.Coinbase:
        return {
          secret: '',
          validate() {
            return !!(this as Coinbase).secret.trim().length
          }
        }
      case CashRegisterType.Paypal:
        return {
          secret: '',
          clientId: '',
          validate() {
            const model = this as Paypal

            return !!model.secret.trim().length && !!model.clientId.trim().length
          }
        }
      case CashRegisterType.Yoomoney:
        return {
          secret: '',
          receiver: '',
          validate() {
            const model = this as Yoomoney

            return !!model.secret.trim().length && !!model.receiver.trim().length
          }
        }
      case CashRegisterType.Yookassa:
        return {
          secret: '',
          shopId: '',
          add_receipt: false,
          default_email: '',
          vat_code: null,
          validate() {
            const model = this as Yookassa

            const mainFields = !!model.secret.trim().length && !!model.shopId.trim().length

            if (mainFields) {
              if (model.add_receipt) {
                return model.vat_code !== null
              } else {
                return true
              }
            } else {
              return false
            }
          }
        }
      case CashRegisterType.Prodamus:
        return {
          login: '',
          secret: '',
          validate() {
            const model = this as Prodamus

            return !!model.login.trim().length && !!model.secret.trim().length
          }
        }
      case CashRegisterType.Robokassa:
        return {
          login: '',
          pass1: '',
          pass2: '',
          add_receipt: false,
          tax: null,
          sno: null,
          validate() {
            const model = this as Robokassa

            const mainFields = !!model.login.trim().length && !!model.pass1.trim().length && !!model.pass2.trim().length

            if (mainFields) {
              if (model.add_receipt) {
                return model.tax !== null && model.sno !== null
              } else {
                return true
              }
            } else {
              return false
            }
          }
        }
      case CashRegisterType.SberbankBusiness:
        return {
          user: '',
          password: '',
          token: '',
          validate() {
            const model = this as SberbankBusiness

            return !!model.user.trim().length && !!model.password.trim().length && !!model.token.trim().length
          }
        }
      case CashRegisterType.Unitpay:
        return {
          secret_key: '',
          project_id: '',
          add_receipt: false,
          receipt_email: '',
          receipt_nds: null,
          validate() {
            const model = this as Unitpay

            const mainFields = !!model.secret_key.trim().length && !!model.project_id.trim().length

            if (mainFields) {
              if (model.add_receipt) {
                return !!model.receipt_email?.trim().length && model.receipt_nds !== null
              } else {
                return true
              }
            } else {
              return false
            }
          }

        }
      case CashRegisterType.PayboxMoney:
        return {
          shop_id: '',
          accept_secret_key: '',
          validate() {
            const model = this as PayboxMoneyType

            return !!model.shop_id.trim().length && !!model.accept_secret_key.trim().length
          }
        }
      case CashRegisterType.WalletPayProvider:
        return {
          key: '',
          validate() {
            const model = this as WalletPayProvider

            return !!model.key.trim().length
          }
        }
      case CashRegisterType.Nowpayments:
        return {
          token: '',
          secret: '',
          validate() {
            const model = this as Nowpayments

            return !!model.token.trim().length && !!model.secret.trim().length
          }
        }
      case CashRegisterType.Cryptobot:
        return {
          token: '',
          validate() {
            const model = this as Cryptobot

            return !!model.token.trim().length
          }
        }
      case CashRegisterType.Cryptocloud:
        return {
          key: '',
          secret: '',
          shop: '',
          validate() {
            const model = this as Cryptocloud

            return !!model.key.trim().length && !!model.secret.trim().length && !!model.shop.trim().length
          }
        }
      // eslint-disable-next-line sonarjs/no-duplicated-branches
      case CashRegisterType.StripeRegister:
        return {
          token: '',
          secret: '',
          validate() {
            const model = this as StripeRegister

            return !!model.token.trim().length && !!model.secret.trim().length
          }
    }
      case CashRegisterType.Cloudpayments:
        return {
          api_secret: '',
          public_id: '',
          validate() {
            const model = this as CloudpaymentsRegister

            return !!model.api_secret.trim().length && !!model.public_id.trim().length
          }
        }
    }

  }

  currencyList(type?: CashRegisterType): Array<SelectOption> {
    if (type) {
      if (type === CashRegisterType.Telegram) {
        return this.currencyOptions([
          { label: "RUB", value: "RUB" },
          { label: "USD", value: "USD" },
          { label: "EUR", value: "EUR" },
          { label: "XTR", value: "XTR" },
        ])
      }
      if (type === CashRegisterType.Prodamus) {
        return this.currencyOptions([
          { label: "RUB", value: "RUB" },
          { label: "USD", value: "USD" },
          { label: "EUR", value: "EUR" },
        ])
      } else if (type === CashRegisterType.Paypal || type === CashRegisterType.StripeRegister) {
        return this.currencyOptions([
          { label: "USD", value: "USD" },
          { label: "EUR", value: "EUR" },
        ])
      } else if (type === CashRegisterType.Coinbase
        || type === CashRegisterType.Cryptobot
        || type === CashRegisterType.Cryptocloud
        || type === CashRegisterType.Nowpayments
      ) {
        return this.currencyOptions([
          { label: "USD", value: "USD" },
        ])
      } else if (type === CashRegisterType.Cloudpayments) {
        return this.currencyOptions([
          { label: "RUB", value: "RUB" },
          { label: "EUR", value: "EUR" },
        ])
      } else {
        return this.currencyOptions([
          { label: "RUB", value: "RUB" },
        ])
      }
    }

    return []
  }

  get paymentSystemTypes(): Array<SelectOptionData> {
    return Object.values(CashRegisterType).map((t) => {
      return {
        label: this.$t(`cash_register_type_option_${ snakeCase(t) }`).toString(),
        value: t,
      }
    })
  }

  numInputModelSetter(args: FieldData): FieldData {
    args.setter = value => {
      if (/[0-9]/.test(value)) {
        args.model[args.key] = value.trim().replace(/[a-zA-Zа-яА-я]/g, '')
      }
    }

    return args
  }
}
